/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import Table, { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import {
  ITableComponent,
  ITableComponentRes,
} from '../../interfaces/table-component';
import {
  ExpandableConfig,
  FilterValue,
  SorterResult,
  TableRowSelection,
} from 'antd/es/table/interface';

interface IProps<T> {
  loading: boolean;
  criteria?: Partial<ITableComponent<T>>;
  columns: ColumnsType<T>;
  data: ITableComponentRes<T>;
  rowSelection?: TableRowSelection<T>;
  onTableChange?: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<T> | SorterResult<T>[],
  ) => void;
  onSelectRowKeys?: (items: T[]) => void;
  expandable?: ExpandableConfig<T> | undefined;
  showPagination?: boolean;
  scroll?: boolean;
  scrollLength?: number;
  scrollYLength?: number;
  rowClassName?: string | undefined;
  summary?: (data: any) => ReactNode | undefined;
  rowKey?: string;
  defaultPagination?: boolean;
  sticky?: boolean | { offsetHeader?: number } | undefined;
}

const TableComponent = <T,>({
  loading,
  criteria,
  data,
  columns,
  rowSelection,
  onTableChange,
  expandable,
  showPagination = true,
  scroll = true,
  scrollLength = 1200,
  scrollYLength,
  rowClassName = undefined,
  summary = undefined,
  rowKey = 'id',
  defaultPagination,
  sticky,
}: IProps<T>) => {
  return (
    <div className="flex flex-col gap-3 w-full">
      <Table
        rowSelection={rowSelection as any}
        loading={loading}
        scroll={scroll ? { x: scrollLength, y: scrollYLength } : undefined}
        rowKey={rowKey || (r => (r as any).id)}
        columns={columns as any}
        dataSource={(data?.data as any) || ([] as any)}
        size="small"
        bordered
        className="font-ibm"
        pagination={
          defaultPagination
            ? undefined
            : showPagination
              ? {
                  pageSize: criteria?.pageSize || 10,
                  current: criteria?.pageStart || 1,
                  total: data?.totalRecords || 0,
                  showTotal: total => `${total} รายการ`,
                  showSizeChanger: true,
                  locale: { items_per_page: '/หน้า' },
                }
              : false
        }
        locale={{
          emptyText: 'ไม่พบรายการ',
        }}
        onChange={(p, f, s) =>
          (onTableChange && onTableChange(p, f, s as any)) ?? undefined
        }
        expandable={expandable as any}
        rowClassName={rowClassName}
        summary={summary}
        sticky={sticky}
      />
    </div>
  );
};

export default TableComponent;
